/*
  Sitewide localization selector runtime.
  Contact-form validation lives in contact-form.js and is loaded only where its
  owning section is rendered.
*/
(function () {
  'use strict';

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      if (!this.elements.button) return;

      this._onButtonClick = this.openSelector.bind(this);
      this._onKeyUp = this.onContainerKeyUp.bind(this);
      this._onItemClick = this.onItemClick.bind(this);
      this._onClickOutside = this.handleClickOutside.bind(this);

      this.elements.button.addEventListener('click', this._onButtonClick);
      this.addEventListener('keyup', this._onKeyUp);
      this.addEventListener('click', this._onItemClick);
      document.addEventListener('click', this._onClickOutside);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onClickOutside);
    }

    hidePanel() {
      if (this.elements.button.getAttribute('aria-expanded') !== 'false') {
        this.elements.button.setAttribute('aria-expanded', 'false');
      }
      if (this.elements.panel && !this.elements.panel.hasAttribute('hidden')) {
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    openSelector() {
      this.elements.button.focus();
      if (this.elements.panel) this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    onContainerKeyUp(event) {
      if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      const item = event.target.closest('a[data-value]');
      if (!item || !this.contains(item)) return;
      event.preventDefault();
      const form = this.querySelector('form');
      const isoValue = item.dataset.value;
      const prevValue = this.elements.input ? this.elements.input.value : '';
      if (this.elements.input) this.elements.input.value = isoValue;
      if (
        this.elements.input &&
        this.elements.input.name === 'country_code' &&
        isoValue !== prevValue &&
        typeof window.rb === 'function'
      ) {
        window.rb('mevent', 'currency-change', undefined, isoValue);
      }
      if (form) form.submit();
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) this.hidePanel();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }
})();
